import { httpClient } from "@services/api/httpClient";

export interface GetPublicOfferListParams {
  language?: string;
  itemsPerPage?: number;
  page?: number;
  search?: string | null;
  tag?: string | null;
  targetCountry?: string;
  categoryId?: number;
}

export async function getOfferListByTag({
  language = "en",
  itemsPerPage = 6,
  page = 1,
  tag,
  search,
  targetCountry,
  categoryId,
}: GetPublicOfferListParams = {}) {
  const response = await httpClient.get("/offer/get-list-by-tag", {
    params: { language, itemsPerPage, page, tag, search, targetCountry, categoryId },
  });

  return response.data;
}
